import { useQuery } from '@apollo/client';

import { GET_ME } from '../queries/getMe';

/**
 * Who gets the "Add person" form.
 *
 * **Reads the server's own answer** (`Membership.canCreatePerson`) rather than rebuilding it from
 * role names here. This used to be `isAdmin || isCenterManager`, computed in
 * `ResponsiveContainer`, which was a copy of a server rule living on the wrong side of the wire:
 * which roles carry `CREATE_PERSON` is per-organisation data edited on `/admin/roles`, so the
 * copy goes stale silently — either hiding a form the server would serve, or offering one it
 * refuses.
 *
 * The same construction as `useCanAccessLeadership`, and for the same reason.
 */
export const useCanCreatePerson = () => {
  const [result] = useCanCreatePersonLoading();

  return result;
};

/**
 * The same answer with the loading flag, for the page itself.
 *
 * A menu entry can treat "not loaded yet" as "no" and simply appear a moment later. A *page*
 * cannot: redirecting on the un-loaded value bounces the person off a page they are allowed to
 * see, before the server has been asked. Same split as `useIsAdminLoading`.
 */
export const useCanCreatePersonLoading = (): [boolean, boolean] => {
  const { data, loading, error } = useQuery(GET_ME);

  return [!loading && !error && !!data?.me?.organisation?.membership?.canCreatePerson, loading];
};
